// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pfaqEntity from './entities/pfaq.json';
import pfaqMenu from '../pages/pfaq/menu.json';
import pfaqFullForm from '../pages/pfaq/forms/full.json';
import pfaqContextForm from '../pages/pfaq/forms/context.json';
import pfaqMiniForm from '../pages/pfaq/forms/mini.json';
import pfaqLookupForm from '../pages/pfaq/forms/lookup.json';
import pfaqTableView from '../pages/pfaq/views/table.json';
import pfaqStagesView from '../pages/pfaq/views/stages.json';
import pfaqCardsView from '../pages/pfaq/views/cards.json';
import pfaqInlineView from '../pages/pfaq/views/inline.json';
import pfaqBacklogView from '../pages/pfaq/views/backlog.json';
import pfaqSplitView from '../pages/pfaq/views/split.json';
import pfaqCalendarView from '../pages/pfaq/views/calendar.json';
import pfaqDashboardView from '../pages/pfaq/views/dashboard.json';

/** Тип запису «Питання» зі сторінками пакета: меню, форми та подання з pages/pfaq/. */
export const pfaqDefinition: IRecordTypeDefinition = {
  ...pfaqEntity,
  views: assembleViewSet({
      table: pfaqTableView,
      stages: pfaqStagesView,
      cards: pfaqCardsView,
      inline: pfaqInlineView,
      backlog: pfaqBacklogView,
      split: pfaqSplitView,
      calendar: pfaqCalendarView,
      dashboard: pfaqDashboardView,
  }),
  form: pfaqFullForm,
  forms: { full: pfaqFullForm, context: pfaqContextForm, mini: pfaqMiniForm, lookup: pfaqLookupForm },
  menu: pfaqMenu,
} as IRecordTypeDefinition;
